import { createSlice } from '@reduxjs/toolkit';

export const AGENT_PROFILE_PICTURE_SLICE_NAME = 'agentProfilePictures';

const initialState = {
  /**
   * Armazena a URL da imagem resolvida (sucesso ou fallback) para cada login.
   * @type {Object.<string, string>}
   */
  imageMap: {}
};

/**
 * Armazena o cache das URLs de fotos de perfil dos agentes.
 */
const agentProfilePicturesSlice = createSlice({
  name: AGENT_PROFILE_PICTURE_SLICE_NAME,
  initialState,
  reducers: {
    /**
     * Define a URL da imagem para um agente no cache.
     * @param {object} state - O estado atual do slice.
     * @param {object} action - A ação despachada.
     * @param {string} action.payload.login - O login (ou ID) do agente.
     * @param {string} action.payload.url - A URL resolvida (seja a .png ou o logoG4).
     */
    setAgentProfilePicture(state, action) {
      const { login, url } = action.payload;
      if (login && url) {
        state.imageMap[login] = url;
      }
    },
    /**
     * Limpa todo o cache de fotos de perfil.
     */
    clearAgentProfilePictureCache(state) {
      state.imageMap = {};
    }
  }
});

export const { setAgentProfilePicture, clearAgentProfilePictureCache } =
  agentProfilePicturesSlice.actions;

export default agentProfilePicturesSlice.reducer;
